import { useRef, useState } from 'react';

import { useCreatePieceAnnotationsMutation } from '@api/pieceAnnotation';
import { AnnotationType } from '@apiContract';
import { toast } from 'sonner';

import { getPieceTypeByWorkflow } from '@utils/piece';

import { AnnotationsMail, AnnotationsPackage, getAnnotationsMapByType } from './helpers';
import { AdditionalInfoProps } from '.';

export const useAdditionalInfo = ({ annotations, piece, onCreate, onClose }: AdditionalInfoProps) => {
  const [createPieceAnnotations, { isLoading }] = useCreatePieceAnnotationsMutation();

  const infoAnnotations = annotations.filter((annotation) =>
    [...AnnotationsPackage, ...AnnotationsMail].includes(annotation.annotationType),
  );

  const pieceType = getPieceTypeByWorkflow(piece?.workflow);

  const [annotationsState, setAnnotations] = useState(getAnnotationsMapByType(infoAnnotations, pieceType));
  const prevAnnotationLengthRef = useRef<number>(infoAnnotations.length);
  const [alertDismissed, setAlertDismissed] = useState<boolean>(false);

  const showDetectedAlert = prevAnnotationLengthRef.current === 0 && infoAnnotations.length > 0 && !alertDismissed;

  if (!showDetectedAlert) {
    prevAnnotationLengthRef.current = infoAnnotations.length;
  }

  const refreshMailClass = () => {
    setAnnotations(getAnnotationsMapByType(infoAnnotations, pieceType));
    setAlertDismissed(true);
  };

  const onChangeValue = (annotationType: AnnotationType, value: string) =>
    setAnnotations({ ...annotationsState, [annotationType]: value });

  const saveAnnotations = async () => {
    try {
      const nextAnnotations = await createPieceAnnotations({
        annotations: Object.keys(annotationsState).map((annotationType) => ({
          pieceId: piece?.id,
          annotationType: +annotationType,
          textValue: annotationsState[annotationType],
        })),
      });
      
      if (onCreate) {
        onCreate(nextAnnotations.data?.objectData);
      }
      onClose();
    } catch (error) {
      toast.error('Something got wrong');
    }
  };

  return {
    showDetectedAlert,
    refreshMailClass,
    pieceType,
    annotationsState,
    onChangeValue,
    isLoading,
    saveAnnotations,
  };
};
